import React from 'react';
import ThemeWrapper from '../components/styles/ThemeWrapper/index.js';
import ErrorBoundary from '../components/errors/ErrorBoundary';
import Flexbox from 'flexbox-react';
import { Provider } from 'mobx-react';
import Feedback360View from './Feedback360View';

export default class TemplateBuilderView extends React.Component {
  render() {
    const { accountId } = this.props;

    return (
      <Provider>
        <ThemeWrapper>
          <ErrorBoundary>
            <Flexbox
              flexGrow={1}
              width="100%"
              alignContent="stretch"
              flexDirection="column"
              paddingBottom="0px"
            >
              <Feedback360View />
            </Flexbox>
          </ErrorBoundary>
        </ThemeWrapper>
      </Provider>
    );
  }
}
